import React from "react";
import { Link } from 'react-router-dom';
import { Col, Container, Modal, Row, Table, Button } from "react-bootstrap";
import ExclamacionIcon from '../../styles/icons/exclamation-circle.svg'
import { obtenerUnidad, eliminarUnidad } from "./OrganizacionService";
import MiembroDialogContent from "./Miembro";
import UnidadDialogContent from "./Unidad";
import PropTypes from "prop-types";


class InfoUnidad extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: "",
            descripcion: "",
            unidadPadre: "",
            unidadPadreDescripcion: "",
            miembros: [],
            empresa: "",
            correoNotificacion: "",
            dialogEliminarUnidad: false,
            editUnidad: false,
            unidad: {},
        };

    }

    dialogRef = React.createRef();


    handleChange = (event) => {
        this.setState({ ...this.state, [event.target.name]: event.target.checked });
    };

    handleEditUnidad = () => {
        this.setState(
            {
                dialogTitle: "Editar Unidad",
                dialogType: "edit",
                submitText: "Editar",
                disabledInput: false,
            },
        );
        this.setState({ unidad: { id: this.state.id, unidadPadreID: this.state.unidadPadre, descripcion: this.state.descripcion, correoNotificacion: this.state.correoNotificacion } })
        this.handleDialogEditUnidad(true);
    };

    componentDidUpdate(prevProps) {
        if (!prevProps.abierto && this.props.abierto) {
            const dialog = this.dialogRef.current;

            if (dialog && typeof dialog.showModal === "function") {
                requestAnimationFrame(() => {
                    dialog.showModal();
                });
            }
        }

        if (prevProps.abierto && !this.props.abierto) {
            this.dialogRef.current?.close();
        }
    }

    handleDialogEliminarUnidad = (value, mensaje = "") => {
        this.setState({
            dialogEliminarUnidad: value
        })
    }

    eliminarUnidad = () => {
        this.handleDialogEliminarUnidad(false);
        /**Mientras tanto muestra un mensaje exitoso en la pantalla principal**/
        eliminarUnidad(this.state.id).then((resp) => {
            this.props.handleClose(false, null, resp.error, resp.mensaje)
        })
    }

    handleClickEliminarUnidad = () => {
        const unidadActual = {
            id: this.state.id,
            descripcion: this.state.descripcion,
            unidadPadreDescripcion: this.state.unidadPadreDescripcion,
            correoNotificacion: this.state.correoNotificacion,
        };

        if (this.props.onEliminarUnidad) {
            this.props.onEliminarUnidad(unidadActual);
        }
    };

    handleInput = (e) => {
        var name = e.target.name;
        var val = e.target.value;
        this.setState({
            [name]: val,
        });
    };

    handleDialogAgregarMiembro = (value, error = false, mensaje = "") => {
        if (!value) {
            this.componentDidMount()
        }
        if (mensaje != "") {
            this.setState({
                mostrarMensajeFlash: true,
                mensajeFlash: mensaje,
                severity: error ? "danger" : "success"
            })
        }
        this.setState({
            agregarMiembro: value,
        })
    }

    cargarDetalles = (nodo) => {
        this.setState({
            id: nodo.id,
            descripcion: nodo.descripcion,
            unidadPadre: nodo.unidadPadre,
            unidadPadreDescripcion: nodo.unidadPadreDescripcion,
            miembros: nodo.miembros,
            empresa: nodo.empresa,
            correoNotificacion: nodo.correoNotificacion,
        })
    };

    renderContenidoTabla = () => {
        if (this.state.miembros != null) {
            return (
                this.state.miembros.map((elemento) => (
                    <tr key={elemento.id}>
                        <td component="th" scope="row">
                            {elemento.name + " " + elemento.lastname}
                        </td>
                        <td>{elemento.username}</td>
                        <td>{elemento.cedula}</td>
                        <td>{elemento.cargo}</td>
                    </tr>
                )));
        } else {
            return (
                <tr>
                    <td colSpan="4" style={{ textAlign: "center", padding: "20px" }}>
                        Esta unidad no posee miembros
                    </td>
                </tr>
            );
        }
    }

    render() {

        return (
            <div>

                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.dialogEliminarUnidad}
                    onHide={this.handleDialogEliminarUnidad}
                    backdrop="static"
                    keyboard="false"
                >
                    <Container>
                        <Modal.Body>
                            <Row className="justify-content-center">
                                <Col className="text-center text-md-right">
                                    <img src={ExclamacionIcon} style={{ margin: '40px' }}></img>
                                </Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col className="text-center text-md-right">
                                    <p><strong>Estas Seguro que desea eliminar esta unidad?</strong></p>
                                </Col>
                            </Row>
                            <Row style={{ background: "#EDF2F9" }}>
                                <Col>
                                    <p><strong>Descripcion:</strong> {this.state.descripcion}</p>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.handleDialogEliminarUnidad(false)} variant="contained">Cancelar</Button>
                            <Button onClick={this.eliminarUnidad} color="primary" autoFocus>
                                Aceptar
                            </Button>
                        </Modal.Footer>
                    </Container>
                </Modal>
                <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.agregarMiembro}
                    onHide={() => this.handleDialogAgregarMiembro(false)}
                    backdrop="static"
                    keyboard="false"
                >
                    <MiembroDialogContent
                        handleClose={this.handleDialogAgregarMiembro}
                        type={this.state.dialogType}
                        submitText={this.state.submitText}
                        disabledInput={this.state.disabledInput}
                        miembros={this.state.miembros}
                        unidadID={this.state.id}
                    />
                </Modal>
                <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.editUnidad}
                    onHide={() => this.handleDialogEditUnidad(false)}
                    backdrop="static"
                    keyboard="false"
                >
                    <UnidadDialogContent
                        handleClose={this.handleDialogEditUnidad}
                        type={this.state.dialogType}
                        submitText={this.state.submitText}
                        disabledInput={this.state.disabledInput}
                        edit={true}
                        unidad={this.state.unidad}
                    />
                </Modal>

                <div className="component-modal-side" id="modal-detalles-unidad">
                    <dialog
                        className="modal"
                        id="modal-detalles-unidad"
                        ref={this.dialogRef}
                    >
                        <div className="modal-content">
                            <div className="modal-head">
                                <h4 className="modal-title"> Detalles de la unidad </h4>
                                <div className="actions">
                                    <button
                                        className="btn-medium btn-circle-icon btn-primary-tonal"
                                        id="close-modal"
                                        onClick={this.props.onClose}
                                    >
                                        <span className="material-symbols-outlined">close</span>
                                    </button>

                                    <Link
                                        to={{
                                            pathname: "/estructura/organizacion/editar-unidad",
                                            state: {
                                                id: this.state.id,
                                                descripcion: this.state.descripcion,
                                                unidadPadre: this.state.unidadPadre,
                                                unidadPadreDescripcion: this.state.unidadPadreDescripcion,
                                                miembros: this.state.miembros,
                                                empresa: this.state.empresa,
                                                correoNotificacion: this.state.correoNotificacion,
                                            },
                                        }}
                                        className="btn-small btn-primary-tonal"
                                    >
                                        <span className="material-symbols-outlined">edit</span>
                                    </Link>
                                    <button
                                        className="btn-small btn-primary-tonal"
                                        onClick={this.handleClickEliminarUnidad}
                                    >
                                        <span className="material-symbols-outlined">delete</span>
                                    </button>
                                </div>
                            </div>

                            <div className="modal-body">
                                <div className="card">
                                    <div className="card-content">
                                        <div className="content-inner">
                                            <span className="label"> Descripción </span>
                                            <span className="txt"> {this.state.descripcion} </span>
                                        </div>
                                        <div className="content-inner">
                                            <span className="label"> Unidad Padre </span>
                                            <span className="txt"> {this.state.unidadPadreDescripcion != null ? this.state.unidadPadreDescripcion : "Ninguno"}  </span>
                                        </div>
                                        <div className="content-inner">
                                            <span className="label"> Dirección de e-mail para notificaciones </span>
                                            <span className="txt"> {this.state.correoNotificacion} </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="content-table">
                                    <h5 className="contentTitle"> Miembros de la unidad </h5>

                                    <div className="table-responsive">
                                        <table className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th scope="col"> Nombre </th>
                                                    <th scope="col"> Usuario </th>
                                                    <th scope="col"> CI </th>
                                                    <th scope="col"> Cargo </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.renderContenidoTabla()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dialog>
                </div>
                );
            </div>
        );
    }
}

InfoUnidad.propTypes = {
    abierto: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onEliminarUnidad: PropTypes.func,
};

export default InfoUnidad;
